import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { Tenant } from "./tenant.model";
import { TENANT_KEY, NOME_CONTA_KEY, TENANT_SCHEMA, HABILITAR_SITUATOR_ZONAS } from 'app/const';
import { AppFilter } from "app/models/app-filter.model";
import { IID } from '../../../../shared/auth/auth.service';
import { AbTenant } from 'app/abstract/full-pages/admin/tenant.abstract';
import { toBinaryStr } from 'app/commons/toBinaryStr';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends AbTenant {

  getAllTenants(filter: AppFilter): Observable<any> {
    return this.getAll("admin/tenants/filter/", filter.encode());
  }

  getAllContas(filter: AppFilter): Observable<any> {
    return this.getAll("admin/tenants/all/", filter.encode());
  }

  getTenantById(id: number): Observable<any> {
    return this.get(`admin/tenants/${id}`);
  }

  getTenantMigrar(id: number): Observable<any> {
    return this.get(`admin/tenants/migrar/${id}`);
  }

  migrar(tenant: any): Observable<any> {
    return this.post('admin/tenants/migrar', tenant);
  }

  salvar(tenant: Tenant): Observable<any> {
    return this.save("admin/tenants/", tenant);
  }

  salvarEndereco(id: number, endereco: any): Observable<any> {
    return this.put("admin/tenants/endereco", id, endereco);
  }

  salvarTenantStorage(tenant: Tenant) {
    this.salvarSituatorZonasHabilitados(tenant.habilitarSituatorZona);
    const basic = btoa(toBinaryStr(JSON.stringify(tenant)));
    sessionStorage.setItem(TENANT_KEY, basic);
  }

  salvarNomeTenantStorage(tenant: string) {
    const basic = JSON.stringify(tenant);
    sessionStorage.setItem(NOME_CONTA_KEY, basic);
  }

  salvarSituatorZonasHabilitados(isHabilitarSituatorZona: boolean) {
    const habilitarSituatorZona = JSON.stringify(isHabilitarSituatorZona);
    sessionStorage.setItem(HABILITAR_SITUATOR_ZONAS, habilitarSituatorZona)
  }

  isSituatorNovaApiHabilitado() {
    return JSON.parse(sessionStorage.getItem(HABILITAR_SITUATOR_ZONAS))
  }

  getNomeTenantStorage(): Tenant {
    const t = sessionStorage.getItem(NOME_CONTA_KEY);
    return JSON.parse(t);
  }

  limparTenantStorage() {
    sessionStorage.removeItem(TENANT_KEY);
    sessionStorage.removeItem(NOME_CONTA_KEY);
  }

  salvarTenantSchemaStorage(schema: string) {
    sessionStorage.setItem(TENANT_SCHEMA, schema);
  }

  getTenantSchemaStorage(): string {
    return sessionStorage.getItem(TENANT_SCHEMA);
  }

  limparTenantSchemaStorage() {
    sessionStorage.removeItem(TENANT_SCHEMA);
  }

  getTenantStorage(): Tenant {
    const t = sessionStorage.getItem(TENANT_KEY);
    let base64 = null;

    if (!t) {
      return base64;
    }

    try {
      base64 = atob(t);
    } catch (error) {
      console.error('erro ao criptografar.')
    }
    return base64 ? JSON.parse(base64) : base64;
  }

  desativar(id: number, senha: string): Observable<any> {
    const usuario = {
      senha: senha
    };
    return this.put('admin/tenants/desativar', id, usuario);
  }

  getOnlyNumberIdenfiersTenant(): string {
    const t = this.getTenantStorage();
    return t ? t.schema.replace(/\D+/g, "") : undefined;
  }

  getAllTenantsIntegrador(): Observable<any> {
    return this.getAll("admin/tenants/integrador");
  }

  getTenantsSearch(searchString): Observable<any> {
    const integradorId = sessionStorage.getItem(IID)
    return this.get(`public/admin/tenants/integrador/${integradorId}/contas/search/${searchString}`);
  }

  getTenantsPreCadastroSearch(codigoPreCadastro: string): Observable<any> {
    const integradorId = sessionStorage.getItem(IID);
    return this.get(`public/admin/tenants/integrador/${integradorId}/contas/pre-cadastro/validate?codigoPreCadastro=${codigoPreCadastro}`);
  }

  getTenantByIdPublic(id): Observable<any> {
    return this.get(`public/admin/tenants/${id}`);
  }

  validarConfigNotificacao(): Observable<any> {
    return this.get('admin/tenants/validar_config_notificacao');
  }

  getAllTenantsAtivosPorNome(filter: AppFilter) {
    return this.get(`admin/tenants/ativos/${filter.encode()}`);
  }

  getAllContasAtivasPeloNome(filter: AppFilter) {
    return this.get(`admin/tenants/contas/ativos/${filter.encode()}`);
  }

  updateVoipApp(tenant: Tenant): Observable<any> {
    return this.put('admin/tenants/update_voip_app', tenant.id, tenant);
  }

  concederPermissao(tenant: Tenant) {
    return this.get(`admin/tenants/permissao/${tenant.schema}`);
  }

  getTenantConta(): Observable<any> {
    return this.get(`admin/tenants/dss_layout`);
  }

}
